export const getInitials = function (fullName: string) {
	const names = fullName.trim().split(' ');
	let initials = names[0].substring(0, 1);

	if (names.length > 1) {
		initials += names[names.length - 1].substring(0, 1);
	}
	return initials.toUpperCase();
};

export const handleEntityPluralCase = (count: number, entity: string, customFormat = '') => {
	if (count > 1 || count === 0) return !customFormat ? `${entity}s` : customFormat;

	return entity;
};

export function formatPlural(value: number, singular: string) {
	return `${value} ${singular}${value === 1 ? '' : 's'}`
}

export function plainText(html: string | undefined) {
	return (html || '').replace(/<[p]>/g, '\n\n').replace(/<[h][1]>/g, '\n\n').replace(/<[h][2]>/g, '\n\n').replace(/<[h][3]>/g, '\n\n').replace(/<[h][4]>/g, '\n\n').replace(/<[^>]+>/g, '')
}

export const capitalizeFirstLetter = (val: string) => val.charAt(0).toUpperCase() + val.slice(1);
